import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import UiInputMoney from '../../components/Form/UiInputMoney';

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div style={{ flex: 1, minWidth: 280 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, color: '#94a3b8', textTransform: 'uppercase', marginBottom: 12 }}>
            {title}
        </div>
        {children}
    </div>
);

function InputsDemo() {
    const methods = useForm({ defaultValues: { old: 0 } });
    const values = methods.watch();

    return (
        <FormProvider {...methods}>
            <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                <Section title="UiInputMoney">
                    <UiInputMoney label="Valor (R$)" name="old" />
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>
                        Valor no form: <strong>{values.old}</strong>
                    </div>
                </Section>
            </div>

            <div style={{ marginTop: 32, display: 'flex', gap: 12 }}>
                <button
                    className="btn btn-sm btn-secondary"
                    type="button"
                    onClick={() => methods.reset({ old: 1599.90 })}
                >
                    Carregar R$ 1.599,90
                </button>
                <button
                    className="btn btn-sm btn-secondary"
                    type="button"
                    onClick={() => methods.reset({ old: 0 })}
                >
                    Resetar
                </button>
            </div>
        </FormProvider>
    );
}

export default function InputsSandbox() {
    return (
        <div style={{ padding: 32, overflowY: 'auto', height: '100%' }}>
            <h2 style={{ marginBottom: 8 }}>Inputs Sandbox</h2>
            <p style={{ color: '#64748b', marginBottom: 32 }}>Comparação entre o input monetário antigo e o novo.</p>
            <InputsDemo />
        </div>
    );
}
